import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { CommingSoon, Dashboard, Users } from '@containers';
import UserMangement from '@containers/UserManagement';
import SiteManagement from '@containers/SiteManagement';
import AddProperty from '@components/StepForm/index';
import ReactScheduler from '@components/Scheduler';
import Sitemanagementdetail from '@containers/SiteManagement/sitemanagementdetail';
import EditProfile from '@containers/Dashboard/Edit Profile';
import MyAvailability from '@containers/Dashboard/My Availability';
import ChangePassword from '@containers/Dashboard/Change Password';
import ClientMangement from '@containers/ClientManagement';
import Settings from '@containers/Settings';
import SecurityIssues from '@containers/SecurityIssues';
import ManageIncidents from '@containers/SecurityIssues/ManageIncident';
import Reports from '@containers/SecurityIssues/Reports';
import IncidentDetail from '@containers/SecurityIssues/ManageIncident/incidentDetail';
import WorkForceManagement from '@containers/WorkForceManagement';
import ShiftScheduler from '@containers/WorkForceManagement/Scheduler';
import AttendenceManagement from '@containers/AttendenceManagement';
import TimeOfRequest from '@containers/WorkForceManagement/TimeOfRequest';
import ManageShift from '../../containers/WorkForceManagement/ManageShift';
import TimeOfRequestDetail from '@containers/WorkForceManagement/TimeOfRequest/TimeOfRequestDetail';
import ViewReport from '@containers/SecurityIssues/Reports/ViewReport.js';
import DropSwapRequestDetail from '../../containers/WorkForceManagement/ManageShift/DropSwapRequestDetail';
import MyShifts from '../../containers/WorkForceManagement/MyShifts';
import { ClientDashboard, ConnectivityHub } from '../../containers';
import { AlertManagement } from '../../containers';
import ClientSideBar from '../../components/Layout/clientsidebar';
import Notification from '../../containers/Notification';
// Patrol admin panel
import PatrolsList from '../../containers/Patrol/Patrols/PatrolsList';
import PatrolDetail from '../../containers/Patrol/Patrols/PatrolDetail';
import FollowUpsPage from '../../containers/Patrol/FollowUps/FollowUpsPage';
import ContactDirectoryPage from '../../containers/ContactDirectory/ContactDirectoryPage';
import PatrolSettingsPage from '../../containers/Settings/PatrolSettings/PatrolSettingsPage';

const AppRoutes = ({ isRole }) => {
    return (
        <div className="App">
            <Routes>
                {isRole === 'admin' ||
                    isRole == 'manager' ||
                    isRole == 'supervisor' ? (
                    <>
                        <Route path="/" element={<Dashboard />} />
                        <Route
                            path="/users-management"
                            element={<UserMangement />}
                        />
                        <Route path="/EditProfile" element={<EditProfile />} />
                        <Route
                            path="/MyAvailability"
                            element={<MyAvailability />}
                        />
                        <Route
                            path="/ChangePassword"
                            element={<ChangePassword />}
                        />
                        <Route
                            path="/site-management"
                            element={<SiteManagement />}
                        />
                        <Route
                            path="/property-details/:id"
                            element={<Sitemanagementdetail />}
                        />
                        <Route path="/add-property" element={<AddProperty />} />
                        <Route
                            path="/emergency-alert"
                            element={<CommingSoon />}
                        />
                        <Route
                            path="/emergency-alert"
                            element={<CommingSoon />}
                        />
                        <Route
                            path="/users-management"
                            element={<UserMangement />}
                        />
                        <Route
                            path="/client-support"
                            element={<ClientMangement />}
                        />
                        <Route
                            path="/alert-management"
                            element={<AlertManagement />}
                        />
                        <Route
                            path="/workforce-management"
                            element={<WorkForceManagement />}
                        />
                        <Route
                            path="/workforce-management/shift-scheduler"
                            element={<ShiftScheduler />}
                        />
                        <Route
                            path="/workforce-management/time-of-request"
                            element={<TimeOfRequest />}
                        />
                        <Route
                            path="/workforce-management/my-shifts"
                            element={<MyShifts />}
                        />
                        <Route
                            path="/workforce-management/drop-swap-requests"
                            element={<ManageShift />}
                        />

                        <Route
                            path="/workforce-management/TOR/detail/:id"
                            element={<TimeOfRequestDetail />}
                        />
                        <Route
                            path="/workforce-management/DSR/detail/:id"
                            element={<DropSwapRequestDetail />}
                        />
                        <Route
                            path="/attendance-management"
                            element={<AttendenceManagement />}
                        />
                        <Route
                            path="/security-issues"
                            element={<SecurityIssues />}
                        />
                        <Route
                            path="/security-issues/manage-incidents"
                            element={<ManageIncidents />}
                        />
                        <Route
                            path="/security-issues/report"
                            element={<Reports />}
                        />
                        <Route
                            path="/security-issues/manage-incidents/report/:id"
                            element={<IncidentDetail />}
                        />
                        <Route
                            path="/security-issues/view-report"
                            element={<ViewReport />}
                        />
                        <Route
                            path="/connectivity-hub"
                            element={<ConnectivityHub />}
                        />
                        <Route
                            path="/Notifications"
                            element={<Notification />}
                        />
                        <Route path="/setting" element={<Settings />} />
                        <Route path="/alert" element={<CommingSoon />} />
                        {/* Patrol admin panel routes */}
                        <Route path="/patrols" element={<PatrolsList />} />
                        <Route path="/patrols/:id" element={<PatrolDetail />} />
                        <Route path="/checkpoint-follow-ups" element={<FollowUpsPage />} />
                        <Route path="/contact-directory" element={<ContactDirectoryPage />} />
                        {/* Patrol settings — admin only (enforced at component level) */}
                        <Route path="/settings/patrol" element={<PatrolSettingsPage />} />
                    </>
                ) : isRole === 'guard' ? null : isRole === 'client' ? (
                    // Render Client Panel Routes
                    <>
                        <Route path="/" element={<SiteManagement />} />
                        <Route
                            path="/property-details/:id"
                            element={<Sitemanagementdetail />}
                        />
                        <Route
                            path="/ChangePassword"
                            element={<ChangePassword />}
                        />
                        {/* 
                        <Route
                            path="/client-support"
                            element={<ClientSupport />}
                        />
                        <Route
                            path="/client-settings"
                            element={<ClientSettings />}
                        /> */}
                    </>
                ) : null}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
};

export default AppRoutes;
// class AppRoutes extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render() {
//     return (
//       <div className="App">
//          <Routes>
//               <Route path="/" element={<Dashboard />} />
//               <Route path="/users" element={<Users />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//       </div>
//     );
//   }
// }

// export default connect((state) => ({ storeState: state }))(AppRoutes);
